module.exports = __webpack_public_path__ + "static/media/Banner.7c3f07ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/Banner.png
// module id = 69
// module chunks = 0